import 'es6-promise/auto'
import Vue from 'vue'
import VueLocale from 'vuex-i18n'

import store from './store'
import router from './router'
import App from './App'

import '@/services/v-md'
import '@/services/v-touch'
import 'gsap/src/uncompressed/plugins/ScrollToPlugin'

Vue.config.productionTip = false
Vue.use(VueLocale.plugin, store)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  ...App,
  store,
  router
})



// WEBPACK FOOTER //
// ./src/main.js